<script lang="ts" setup>
defineProps({
  title: {
    type: String,
    default: '',
  },
  tip: {
    type: String,
    default: '',
  },
  part: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <NuxtLink
    class="flex w-full items-center justify-start rounded border border-lightblack bg-white py-3 pl-6 !transition-colors !duration-500 hover:border-colorText"
    :to="{
      path: '/oj/guide',
      hash: part,
    }"
  >
    <slot></slot>
    <div class="ml-2">
      <h3 class="text-sm font-bold leading-[22px] text-colorText">
        {{ title }}
      </h3>
      <p class="text-xs leading-5 text-colorTextTertiary">{{ tip }}</p>
    </div>
  </NuxtLink>
</template>
